import PropTypes from "prop-types"
import CourseLessonContentContainer from "~/components/Common/CourseLessonContentContainer"
import CourseContent from "~/components/courses/CourseContent"
import CourseSettings from "~/components/courses/CourseSettings"
import Page from "~/pages/Page"
import Router from "~/router"

const Settings = ({ routes = [], ...rest }) => {
  return (
    <Page>
      <CourseLessonContentContainer
        leftComponent={<CourseSettings />}
        rightComponent={<CourseContent />}
      />
      <Router routes={routes} {...rest} />
    </Page>
  )
}

Settings.propTypes = {
  routes: PropTypes.array,
}

export default Settings
